module.exports = __webpack_public_path__ + "static/paolo-guatelli-93e48418bb301e730aefec7198ca24ea.jpg";